import { EmptyContent, Typography } from 'components'

import * as S from './styled'

const EmptyMaterials = () => {
  return (
    <S.Wrapper>
      <Typography design="hav-default-03-text">
        Nesta página, você pode visualizar e editar os materiais em aberto, além de
        usá-los para gerar novas ordens de venda. Os materiais podem estar categorizados
        como rascunho ou indisponível (devido à falta de cota, estoque ou valor mínimo).
        Acesse e edite um material através de 2 cliques na linha correspondente.
      </Typography>

      <EmptyContent
        title="Sem materiais em aberto"
        description={
          <>
            Todos os materiais deste pedido geraram OVs. Caso deseje realizar uma adição
            será necessário fazê-la diretamente dentro de uma OV.
          </>
        }
      />
    </S.Wrapper>
  )
}

export default EmptyMaterials
